import { initI18n } from '@wix/fe-essentials/i18n';
export const loadTranslations = async translationLang => {
  try {
    return (await import(`../locales/messages_${translationLang}.json`)).default;
  } catch (e) {
    return (await import('../locales/messages_en.json')).default;
  }
};
export const initializeI18n = (translations, translationLang) => {
  const i18nConfig = {
    messages: translations,
    locale: translationLang
  };
  const i18n = initI18n(i18nConfig);
  i18n.t = i18n.t.bind(i18n);
  return i18n;
};
export const loadI18n = async translationLang => {
  const translations = await loadTranslations(translationLang);
  const i18n = initializeI18n(translations, translationLang);
  return i18n;
};
//# sourceMappingURL=i18n.js.map